(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-template"]) return;
  try {
    
$('.js-load-more').on('click', function(){
  let $this = $(this);
  const totalPages = parseInt($('[data-total-pages]').val());
  let currentPage = parseInt($('[data-current-page]').val());
  $this.addClass('hide');
  $this.find('[load-more-text]').addClass('hide');
  $this.find('[loader]').removeClass('hide');
  currentPage = currentPage + 1;
  let nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
  $('[data-current-page]').val(currentPage);

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      $('.row.row-cols-1.row-cols-md-2.g-4').append($(responseHTML).find('.row.row-cols-1.row-cols-md-2.g-4').html());
    }, 
    complete: function() {
      if(currentPage < totalPages) {
        $this.removeClass('hide'); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
      } else {
        $this.addClass('hide'); $this.find('[load-more-text]').addClass('hide'); $this.find('[loader]').addClass('hide');
      }
    }
  })
});

$(document).ready(function(){
   $('.template-blog #shopify-section-footer').detach().appendTo($('.template-blog'));
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cyt-collection"]) return;
  try {
    
$('.js-load-more').on('click', function(){
    let $this = $(this);
    const totalPages = parseInt($('[data-total-pages]').val());
    let currentPage = parseInt($('[data-current-page]').val());
    $this.addClass('hide');;
    $this.find('[load-more-text]').addClass('hide');
    $this.find('[loader]').removeClass('hide');
    currentPage = currentPage + 1;
    let nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
    $('[data-current-page]').val(currentPage);
  
    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function(responseHTML){
        $('.row.collection-row').append($(responseHTML).find('.row.collection-row').html());
      }, 
      complete: function() {
        if(currentPage < totalPages) {
          $this.removeClass('hide'); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
        } else {
          $this.addClass('hide'); $this.find('[load-more-text]').addClass('hide'); $this.find('[loader]').addClass('hide');
        }
      }
    })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-content"]) return;
  try {
    
            document.querySelectorAll(".dropdown button.nav-link").forEach(element => {
                element.addEventListener("click", function() {
                    document.querySelector("#dropdownMenuButton1").innerHTML = this.innerHTML;
                })
            })
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-glossary"]) return;
  try {
    
const ingredientLinks = document.querySelectorAll("#ing-sidebar-nav .sidebar-nav__list-item");
const glossaryLinks = document.querySelectorAll("#glos-sidebar-nav .sidebar-nav__list-item");
const ingredientsLetters = document.querySelectorAll(".ingredients-item__main-letter.ingredient-letter.text-uppercase");
const glossaryLetters = document.querySelectorAll(".ingredients-item__main-letter.glossary-letter.text-uppercase");
const navLettersI = document.querySelectorAll("#ing-sidebar-nav .sidebar-nav__list-link.text-uppercase.d-block");
const navLettersG = document.querySelectorAll("#glos-sidebar-nav .sidebar-nav__list-link.text-uppercase.d-block");
const navLettersArrayI = [];
const navLettersArrayG = [];
const ingredientsLettersArray = [];
const glossaryLettersArray = [];


navLettersI.forEach(function(element) {
    navLettersArrayI.push({html: element.innerHTML, element});
})
navLettersG.forEach(function(element) {
    navLettersArrayG.push({html: element.innerHTML, element});
})
ingredientsLetters.forEach(function(element) {
    ingredientsLettersArray.push({html: element.innerHTML, element});
})
glossaryLetters.forEach(function(element) {
    glossaryLettersArray.push({html: element.innerHTML, element});
})

//returns nav elements that have content
const filteredIngredientElements = navLettersArrayI.filter((navLetter) => {
    return ingredientsLettersArray.some((letter) => {
      return letter.html.toLowerCase() === navLetter.html.toLowerCase();
    });
  });

  filteredIngredientElements.forEach(element => {
    element.element.parentElement.classList.remove("no-hover");
  });

const filteredGlossaryElements = navLettersArrayG.filter((navLetter) => {
    return glossaryLettersArray.some((letter) => {
      return letter.html.toLowerCase() === navLetter.html.toLowerCase();
    });
  });

  filteredGlossaryElements.forEach(element => {
    element.element.parentElement.classList.remove("no-hover");
  });

  $('.ingredients-item-wrapper').each(function(){
    $(this).html(
      $(this).find('.ingredients-item').sort(function(a, b) {
        let dsa = $(a).find('h5.ingredients-title').text();
        let dsb = $(b).find('h5.ingredients-title').text();
        return (dsa > dsb ? 1 : (dsa < dsb) ? -1 : 0);
      })
    );  
  });

for (let i = 0; i < ingredientLinks.length; i++) {
    if (!ingredientLinks[i].classList.contains("no-hover") ){
        ingredientLinks[i].addEventListener("click", function() {
            document.querySelector("#ing-sidebar-nav li.active-item")?.classList.remove("active-item");
            ingredientLinks[i].classList.toggle("active-item");
        });
    }
}
for (let i = 0; i < glossaryLinks.length; i++) {
    if (!glossaryLinks[i].classList.contains("no-hover") ){
        glossaryLinks[i].addEventListener("click", function() {
            document.querySelector("#glos-sidebar-nav li.active-item")?.classList.remove("active-item");
            glossaryLinks[i].classList.toggle("active-item");
        });
    }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mob-collection"]) return;
  try {
    
$('.js-load-more').on('click', function(){
    let $this = $(this);
    const totalPages = parseInt($('[data-total-pages]').val());
    let currentPage = parseInt($('[data-current-page]').val());
    $this.addClass('hide');;
    $this.find('[load-more-text]').addClass('hide');
    $this.find('[loader]').removeClass('hide');
    currentPage = currentPage + 1;
    let nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
    $('[data-current-page]').val(currentPage);
  
    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function(responseHTML){
        $('.row.collection-row').append($(responseHTML).find('.row.collection-row').html());
      }, 
      complete: function() {
        if(currentPage < totalPages) {
          $this.removeClass('hide'); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
        } else {
          $this.addClass('hide'); $this.find('[load-more-text]').addClass('hide'); $this.find('[loader]').addClass('hide');
        }
      }
    })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muse-collection"]) return;
  try {
    
$('.js-load-more').on('click', function(){
    let $this = $(this);
    const totalPages = parseInt($('[data-total-pages]').val());
    let currentPage = parseInt($('[data-current-page]').val());
    $this.addClass('hide');;
    $this.find('[load-more-text]').addClass('hide');
    $this.find('[loader]').removeClass('hide');
    currentPage = currentPage + 1;
    let nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
    $('[data-current-page]').val(currentPage);
  
    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function(responseHTML){
        $('.row.collection-row').append($(responseHTML).find('.row.collection-row').html());
      }, 
      complete: function() {
        if(currentPage < totalPages) {
          $this.removeClass('hide'); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
        } else {
          $this.addClass('hide'); $this.find('[load-more-text]').addClass('hide'); $this.find('[loader]').addClass('hide');
        }
      }
    })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-new"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
    }
  };
  request.send();
};
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tinykeepsakes-collection"]) return;
  try {
    
$('.js-load-more').on('click', function(){
    let $this = $(this);
    const totalPages = parseInt($('[data-total-pages]').val());
    let currentPage = parseInt($('[data-current-page]').val());
    $this.addClass('hide');;
    $this.find('[load-more-text]').addClass('hide');
    $this.find('[loader]').removeClass('hide');
    currentPage = currentPage + 1;
    let nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
    $('[data-current-page]').val(currentPage);
  
    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function(responseHTML){
        $('.row.collection-row').append($(responseHTML).find('.row.collection-row').html());
      }, 
      complete: function() {
        if(currentPage < totalPages) {
          $this.removeClass('hide'); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
        } else {
          $this.addClass('hide'); $this.find('[load-more-text]').addClass('hide'); $this.find('[loader]').addClass('hide');
        }
      }
    })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-library-template"]) return;
  try {
    
$('.js-load-more').on('click', function(){
    let $this = $(this);
    const totalPages = parseInt($('[data-total-pages]').val());
    let currentPage = parseInt($('[data-current-page]').val());
    $this.addClass('hide');;
    $this.find('[load-more-text]').addClass('hide');
    $this.find('[loader]').removeClass('hide');
    currentPage = currentPage + 1;
    let nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
    $('[data-current-page]').val(currentPage);
  
    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function(responseHTML){
        $('.row.row-cols-1.row-cols-md-2.g-4').append($(responseHTML).find('.row.row-cols-1.row-cols-md-2.g-4').html());
      }, 
      complete: function() {
        if(currentPage < totalPages) {
          $this.removeClass('hide'); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
        } else {
          $this.addClass('hide'); $this.find('[load-more-text]').addClass('hide'); $this.find('[loader]').addClass('hide');
        }
      }
    })
  });

  } catch(e) { console.error(e); }
})();
})();
